<script setup lang="ts">
const PAGE_TITLE = 'About QxAIOS | AI + Human Quality Review'
const PAGE_DESCRIPTION = 'Learn about QxAIOS and how our platform supports trusted, compliant quality workflows.'
const CANONICAL_URL = 'https://qx.qiksolve.com/about'
const SOCIAL_IMAGE = 'https://qx.qiksolve.com/images/logo.svg'

useSeoMeta({
  title: PAGE_TITLE,
  description: PAGE_DESCRIPTION,
  ogTitle: PAGE_TITLE,
  ogDescription: PAGE_DESCRIPTION,
  ogType: 'website',
  ogUrl: CANONICAL_URL,
  ogImage: SOCIAL_IMAGE,
  twitterCard: 'summary_large_image',
  twitterTitle: PAGE_TITLE,
  twitterDescription: PAGE_DESCRIPTION,
  twitterImage: SOCIAL_IMAGE,
  canonical: CANONICAL_URL,
})

useHead({
  link: [
    {
      rel: 'canonical',
      href: CANONICAL_URL,
    },
  ],
})
</script>

<template>
  <div>
    <h1>About</h1>
    <p>Placeholder content</p>
  </div>
</template>
